import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import EmptyState from 'components/v2/EmptyState'
import Card from '@10xLabs/react-web/components/Card'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { BlockIcon } from '@10xLabs/react-web/components/Icons/Block'
import { Content } from 'components/v2/Content'
import { featureMessages } from 'features/Roles/components/Permissions/messages'

const IconWrapper = styled.div<TSFixMe>`
  margin-bottom: 15px;

  svg {
    width: 40px;
    height: 40px;
    fill: #1976d2;
  }
`

export const ForbiddenView = ({ feature }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
    <Content hasSidebar hasHeader>
      <section>
        <Card.Container>
          <Card.Content noHeader noFooter>
            <EmptyState.Container>
              <IconWrapper>
                <BlockIcon />
              </IconWrapper>

              <EmptyState.Description>
                <FormattedMessage
                  id="forbiddenView.description"
                  defaultMessage="You don&#39;t have access to {feature}."
                  values={{
                    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                    feature: featureMessages[feature]
                      ? // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        intl.formatMessage(featureMessages[feature])
                      : // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        featureMessages[feature]
                  }}
                />
              </EmptyState.Description>

              <EmptyState.Action>
                <FormattedMessage
                  id="forbiddenView.action"
                  defaultMessage="Contact your administrator in order to extend your permissions."
                />
              </EmptyState.Action>
            </EmptyState.Container>
          </Card.Content>
        </Card.Container>
      </section>
    </Content>
  )
}
